/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 11/10/2023
 */

import React from "react";
import { Link } from "react-router-dom";
import {
  Typography,
  Grid,
  Card,
  CardContent,
  CardMedia,
  Button,
} from "@mui/material";
import Styles from "./ServiceDetails.module.css";
import { useGetAllCatWithSubCatQuery } from "../../Store/Services/CategoryService";

const ServiceDetails = () => {
  const { data } = useGetAllCatWithSubCatQuery();
  const renderedCategories = new Set();
  return (
    <div>
      <div className={Styles.container}>
        <Grid container spacing={3}>
          {data &&
            data.map((parentCategory) => {
              if (
                !parentCategory.subCategories ||
                parentCategory.subCategories.length === 0 ||
                renderedCategories.has(parentCategory.catId)
              ) {
                return null;
              }

              renderedCategories.add(parentCategory.catId);

              return (
                <Grid item xs={12} key={parentCategory.catId}>
                  <Card className={Styles.card}>
                    <Grid container>
                      <Grid
                        className={Styles.topCard}
                        item
                        xs={12}
                        md={5}
                        style={{ position: "relative" }}
                      >
                        <div className={Styles.imageOverlay}>
                          <CardMedia
                            component="img"
                            image={`${process.env.REACT_APP_IMAGE_URL}${
                              parentCategory.imageList.split(",")[0]
                            }`}
                            alt={parentCategory.catDisplay}
                            className={Styles.cardMedia}
                          />
                          <div className={Styles.overlayText}>
                            <Typography
                              variant="h4"
                              className={Styles.overlayTitle}
                            >
                              {parentCategory.catDisplay}
                            </Typography>
                            <Typography
                              variant="body1"
                              className={Styles.overlayDescription}
                            >
                              {parentCategory.catDesc}
                            </Typography>
                            <Link
                              to={`/checkout/${parentCategory.catDisplay
                                .split(` `)
                                .join(`-`)
                                .split(`?`)
                                .join(``)
                                .toLowerCase()}?id=${parentCategory.catUuid}`}
                            >
                              <Button
                                className={Styles.button}
                                variant="contained"
                              >
                                BOOK NOW
                              </Button>
                            </Link>
                          </div>
                        </div>
                      </Grid>

                      <Grid item xs={12} md={7} className={Styles.rightColumn}>
                        {/* <CardContent></CardContent> */}

                        <div>
                          <Grid
                            container
                            className={Styles.subCardContainer}
                            justifyContent="center"
                          >
                            {parentCategory.subCategories.map((subCategory) => (
                              <div
                                className={Styles.subCardWrapper}
                                key={subCategory.catId}
                              >
                                <Card className={Styles.subCard}>
                                  <div className={Styles.subCardContent}>
                                    <CardMedia
                                      component="img"
                                      className={Styles.subCardImage}
                                      image={`${
                                        process.env.REACT_APP_IMAGE_URL
                                      }${subCategory.imageList.split(",")[0]}`}
                                      alt={subCategory.catDisplay}
                                    />

                                    <CardContent className={Styles.subCardText}>
                                      <Typography
                                        className={Styles.subCardTextOne}
                                        variant="h6"
                                        style={{
                                          marginBottom: "0.5rem",
                                        }}
                                      >
                                        {subCategory.catDisplay}
                                      </Typography>
                                      <Typography
                                        className={Styles.subCardTextTwo}
                                        variant="body2"
                                        color="rgba(0, 0, 0, 0.651)"
                                      >
                                        {subCategory.catDesc}
                                      </Typography>
                                    </CardContent>
                                  </div>
                                </Card>
                              </div>
                            ))}
                          </Grid>
                        </div>
                      </Grid>
                    </Grid>
                  </Card>
                  {/* <hr className={Styles.divider} /> */}
                </Grid>
              );
            })}
        </Grid>
      </div>
    </div>
  );
};

export default ServiceDetails;
